/** The date an announcement was published, in the person's zone (TMMAPP-0142 U2 item 13a). */
import type { Announcement } from '@/api/announcements';
import { formatInstant } from '@/i18n/format';
import { useLocale } from '@/i18n/useLocale';
import { useMe } from '@/session/meHooks';

export function usePublishedOn() {
  const locale = useLocale();
  const zone = useMe().user.timezone ?? 'UTC';
  return (announcement: Announcement) => {
    try {
      return formatInstant(announcement.publishAt, locale, zone, { dateStyle: 'medium' });
    } catch {
      return '';
    }
  };
}
